export const gridDefaultColDef = {
  resizable: true,
  sortable: true,
};

export function gridColumns() {
  return [
    {
      headerName: 'Country/Region',
      valueGetter: (params) => params.data?.country?.name ?? '',
      sort: 'asc',
      sortable: false,
      flex: 1,
      minWidth: 160,
    },
    {
      headerName: 'Name of the AMO',
      field: 'name',
      flex: 1,
      minWidth: 200,
      sortable: true,
    },
    {
      headerName: 'Name of the AMO Head',
      valueGetter: (params) => {
        const affiliate = params.data?.headAffiliate;
        if (!affiliate) {
          return '';
        }
        return [affiliate.title, affiliate.name, affiliate.surname]
          .filter(Boolean)
          .join(' ')
          .trim();
      },
      flex: 1,
      minWidth: 180,
    },
  ];
}

export function handleAffiliates(rows) {
  return rows ?? [];
}

export function gridRowStyle(params) {
  if (!params.data?.country?.code) {
    return undefined;
  }

  return { cursor: 'pointer' };
}
